import React from "react";

export const Form = ({
  children,
  onSubmit,
  onChange,
  customClassName,
  forwardedFormRef,
}) => {
  if (customClassName) {
    return (
      <form
        className={customClassName}
        onSubmit={onSubmit}
        onChange={onChange}
        ref={forwardedFormRef}
      >
        {children}
      </form>
    );
  }
  return (
    <form onSubmit={onSubmit} onChange={onChange} ref={forwardedFormRef}>
      {children}
    </form>
  );
};
